import { render, staticRenderFns } from "./chooseGoods.vue?vue&type=template&id=27983795&scoped=true"
import script from "./chooseGoods.vue?vue&type=script&lang=js"
export * from "./chooseGoods.vue?vue&type=script&lang=js"
import style0 from "./chooseGoods.vue?vue&type=style&index=0&id=27983795&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27983795",
  null
  
)

export default component.exports